import { RadiusIcon } from './RadiusIcon';

/**
 * author: Michael Richins
 * id DFD4C66B-CD4A-4524-A6DB-E3C2331C5DC6
 * name radius
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radius.svg
 * tags
 * - Math 
 */
export const SphereRadiusIcon = RadiusIcon;
export default SphereRadiusIcon